module.exports = __webpack_public_path__ + "assets/d49ab5de5155e6c665afb52f027ebbc6.svg";